import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import BackSecondImage from "../components/BackSecondImage"

const Project = () => {
  return (
    <>
    <Navbar/>
    <BackSecondImage small="Dive In" big ="Discover My Projects"/>
    <div>Project</div>
    <Footer/>
    </>
  )
}

export default Project